<template>
  <div class="perfis-wizard-stepper">
    <div
      v-for="(step, index) in steps"
      :key="step.id"
      class="perfis-wizard-stepper__item"
      :class="stepItemClass(step)"
    >
      <div class="perfis-wizard-stepper__circle mr-2">
        <v-icon v-if="isCompleted(step)" small color="white"
          >fas fa-check</v-icon
        >
        <span v-else>{{ step.id }}</span>
      </div>
      <div class="perfis-wizard-stepper__text">
        <span class="perfis-wizard-stepper__label">{{ step.label }}</span>
        <span v-if="step.subtitle" class="perfis-wizard-stepper__subtitle">
          {{ step.subtitle }}
        </span>
      </div>
      <v-icon
        v-if="index < steps.length - 1"
        small
        class="perfis-wizard-stepper__arrow mx-3"
      >
        fas fa-chevron-right
      </v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "PerfisUsuarioWizardStepper",
  props: {
    steps: { type: Array, required: true },
    currentStep: { type: Number, required: true },
    completedSteps: { type: Array, default: () => [] }
  },
  methods: {
    isCompleted(step) {
      return this.completedSteps.includes(step.id);
    },
    stepItemClass(step) {
      return {
        "perfis-wizard-stepper__item--active": step.id === this.currentStep,
        "perfis-wizard-stepper__item--completed": this.isCompleted(step)
      };
    }
  }
};
</script>

<style scoped>
.perfis-wizard-stepper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
}
.perfis-wizard-stepper__item {
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: 0.6;
}
.perfis-wizard-stepper__item--active,
.perfis-wizard-stepper__item--completed {
  opacity: 1;
}
.perfis-wizard-stepper__circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}
.perfis-wizard-stepper__item--active .perfis-wizard-stepper__circle {
  background: var(--primary-color, #1976d2);
  color: #fff;
}
.perfis-wizard-stepper__item--completed .perfis-wizard-stepper__circle {
  background: #4caf50;
  color: #fff;
}
.perfis-wizard-stepper__label {
  font-weight: 600;
  font-size: 14px;
}
.perfis-wizard-stepper__subtitle {
  display: block;
  font-size: 11px;
  color: #666;
}
</style>
